import React from "react";

export default function Alert() {
  return (
    <div
      className="alert alert-success m-2 mb-0 d-none"
      id="buyingModalSuccess"
      role="alert"
    >
      تمت الاضافة بنجاح
      <button
        type="button"
        className="close float-left"
        onClick={() => {
          document.getElementById("buyingModalSuccess").classList.add("d-none");
        }}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
}
